import * as React from "react";
import Header from "./Header";
import Survey from "./Survey";
import { SocialData } from "../types";
import StoreContainer from "../stores/StoreContainer";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface PostChatSurveyProps {
  socialData: SocialData;
  agentRating: number;
  isPopout: boolean;
  onSubmit: (answers: any) => void;
  onCollapse: () => void;
  onClose: () => void;
}

class PostChatSurvey extends React.Component<PostChatSurveyProps, {}> {
  surveyContent = StoreContainer.EngagementStore.getPostchatSurveyContent();
  surveyRef: Survey;

  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onClose={this.props.onClose}
          onCollapse={this.props.onCollapse}
        />
        <Survey
          headerText={this.surveyContent.HeaderText}
          survey={this.surveyContent.Survey}
          onSubmit={this.props.onSubmit}
          submitButtonText={this.surveyContent.ButtonText}
          agentRating={this.props.agentRating}
          dynamicProperties={StoreContainer.SettingStore.getCustomVars()}
          visitorName={StoreContainer.VisitorStore.getVisitorName()}
          visitorEmail={StoreContainer.VisitorStore.getVisitorEmail()}
          socialData={this.props.socialData}
          ref={(el) => (this.surveyRef = el)}
        />
      </MessengerFlexContainer>
    );
  }
}

export default PostChatSurvey;
